export default __webpack_public_path__ + "static/kurorty-img-14-631aaefa5adefd4c9c1777661ecaeb30.png";